import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchAllFleetsService } from "../../../services/fleet";
import { setFleets } from "./fleetSlice";
import { showHttpError } from "../../../utils/message";

export const fetchFleets = createAsyncThunk(
  "fleet/fleetList",
  async (_, { dispatch }) => {
    try {
      let response = await fetchAllFleetsService();
      dispatch(setFleets(response));
    } catch (err: any) {
      showHttpError(err);
    } finally {
      dispatch({ type: "END_LOADER" });
    }
  }
);
